import { render } from "./BasicUsage.vue?vue&type=template&id=5c38271a"
import script from "./BasicUsage.vue?vue&type=script&lang=js"
export * from "./BasicUsage.vue?vue&type=script&lang=js"

import "./BasicUsage.vue?vue&type=style&index=0&id=5c38271a&lang=css"
script.render = render

export default script